import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-product-eurail',
    templateUrl: './product-eurail.component.html',
    styleUrls: ['./product-eurail.component.scss']
})

export class ProductEurailComponent {
    public image_baseUrl = environment?.imageUrl;
    public clientAbbr = environment?.clientAbbr;
}